import React, { Fragment } from "react";
import MediaDialog from "../creator-application/common/MediaDialog";
import DialogContentText from "@material-ui/core/DialogContentText";

import Button from "@material-ui/core/Button";

const DeleteModuleGroupDialog = props => {
  const {
    moduleGroup,
    open,
    handleClickClose,
    handleModuleGroupDelete,
  } = props;

  return (
    <MediaDialog
      open={open}
      title="Do you want to delete this module group?"
      content={
        <Fragment>
          <DialogContentText>
            Module Group Name: {moduleGroup.moduleGroupName}
          </DialogContentText>
          <DialogContentText>
            Module Group ID: {moduleGroup.id}
          </DialogContentText>
        </Fragment>
      }
      actions={
        <Fragment>
          <Button onClick={handleClickClose}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => handleModuleGroupDelete(moduleGroup.id)}
          >
            Remove
          </Button>
        </Fragment>
      }
    />
  );

  // return (
  //   <Dialog open={open}>
  //     <DialogTitle>Do you want to delete this module group?</DialogTitle>
  //     <DialogContent>
  //       <DialogContentText>
  //         Module Group Name: {moduleGroup.moduleGroupName}
  //       </DialogContentText>
  //       <DialogContentText>Module Group ID: {moduleGroup.id}</DialogContentText>
  //     </DialogContent>
  //     <DialogActions>
  //       <Button
  //         variant="outlined"
  //         onClick={() => handleModuleGroupDelete(moduleGroup.id)}
  //       >
  //         Delete
  //       </Button>
  //       <Button variant="outlined" onClick={handleClickClose}>
  //         Cancel
  //       </Button>
  //     </DialogActions>
  //   </Dialog>
  // );
};

export default DeleteModuleGroupDialog;
